<div class="wrapper">
    <ion-item class="cal-wrapper" lines="none" #calendar [detail]="false">
        <ion-datetime
            [locale]="locale"
            size="cover"
            show-adjacent-days="true"
            presentation="date"
            [preferWheel]="false"
            [firstDayOfWeek]="1"
            [multiple]="true"
            [(ngModel)]="datetime"
            (ionChange)="onIonChange($event)"
            [highlightedDates]="highlightedDates"
        ></ion-datetime
    ></ion-item>
</div>
